import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import BTLogo from "../assets/images/bt-logo.svg";
import { useAuth } from "../AuthContext";

const Header: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { isAuthenticated, userInfo, logout, login } = useAuth();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  const handleLogin = async () => {
    try {
      // Check if environment variables are configured
      if (!process.env.REACT_APP_ZITADEL_AUTHORITY || !process.env.REACT_APP_ZITADEL_CLIENT_ID) {
        console.error('Zitadel configuration is missing. Please check your environment variables.');
        alert('Zitadel configuration is missing. Please check your environment variables.');
        return;
      }
      await login();
    } catch (err) {
      console.error('Login error:', err);
    }
  };

  return (
    <div id="header-div">
      {isAuthenticated ? (
        <div className="d-flex justify-content-between align-items-center w-100 px-4">
          <div id="header-div-logo">
            <Link to="/dashboard">
              <img src={BTLogo} height={40} alt="Better Trucks Logo" />
            </Link>
          </div>
          <div className="d-flex gap-4 align-items-center">
            <Link
              to="/dashboard"
              className={`text-white text-decoration-none ${location.pathname === '/dashboard' ? 'fw-bold' : ''}`}
            >
              Dashboard
            </Link>

            <Link
              to="/analytics"
              className={`text-white text-decoration-none ${location.pathname === '/analytics' ? 'fw-bold' : ''}`}
            >
              Analytics
            </Link>

            <Link
              to="/analytics-map"
              className={`text-white text-decoration-none ${location.pathname === '/analytics-map' ? 'fw-bold' : ''}`}
            >
              Analytics Map
            </Link>

            <div style={{
              display: 'flex',
              alignItems: 'center',
              marginLeft: '1rem',
              padding: '0.25rem 0.75rem',
              background: 'rgba(255, 255, 255, 0.15)',
              borderRadius: '4px',
              color: '#fff'
            }}>
              <i className="bi bi-person-circle me-2" style={{ fontSize: '14px' }}></i>
              <span style={{ fontWeight: 500, fontSize: '14px' }}>
                {userInfo?.email || 'User'}
              </span>
            </div>
            <button
              onClick={handleLogout}
              className="btn btn-outline-light btn-sm"
              style={{ fontWeight: 600 }}
            >
              <i className="bi bi-box-arrow-right me-1"></i>
              Logout
            </button>
          </div>
        </div>
      ) : (
        <div className="d-flex justify-content-between align-items-center w-100 px-4">
          <div id="header-div-logo">
            <img src={BTLogo} height={40} alt="Better Trucks Logo" />
          </div>
          <button
            onClick={handleLogin}
            className="btn btn-outline-light btn-sm"
            style={{ fontWeight: 600 }}
          >
            <i className="bi bi-box-arrow-in-right me-1"></i>
            Login
          </button>
        </div>
      )}
    </div>
  );
};

export default Header;
